import { createContext, useContext, type PropsWithChildren } from 'react';
import type { Navigator } from './types';

const NavigatorContext = createContext<Navigator | null>(null);

export interface NavigatorProviderProps extends PropsWithChildren {
  /** 미리 만들어진 `Navigator` 인스턴스. lifecycle owner 는 호출자 (app/runtime). */
  navigator: Navigator;
}

/**
 * `Navigator` context provider — 인스턴스 lifecycle 은 모름. 인스턴스 생성·routerRef
 * 연결·bridge 의존은 호출자 (composition root) 가 책임 (inversion of control,
 * `ApiAppLegacyProvider` 패턴 정합).
 *
 * Module singleton (`app/runtime` 의 `navigator`) 이 React 트리 밖 (composition 콜백
 * 등) 사용처와 동일 인스턴스 — provider 는 그 instance 를 트리에 노출하는 표면만.
 */
export function NavigatorProvider({ children, navigator }: NavigatorProviderProps) {
  return <NavigatorContext.Provider value={navigator}>{children}</NavigatorContext.Provider>;
}

export function useNavigator(): Navigator {
  const ctx = useContext(NavigatorContext);
  if (!ctx) throw new Error('useNavigator must be used within NavigatorProvider');
  return ctx;
}
